export default "__VITE_ASSET__a35a340a__"